export default function(array, key, value) {
  const result = {};
  for(let item of array) {
    if(value) {
      result[item[key]] = item[value];
    } else {
      result[item[key]] = item;
    }

  }

  return result;
}
